<template>
  <ion-app>
    <ion-content>
      <v-container fluid id="brandProductList">
        <div class="van-hairline--bottom background_color_d6f1ec van-nav-bar" style="z-index: 1;">
          <div class="van-nav-bar__left" v-show="$vuetify.breakpoint.smAndDown">
            <i class="van-icon van-icon-arrow-left van-nav-bar__arrow" style="color: #000000 !important;" @click="onClickBack"></i>
          </div>
          <div class="van-ellipsis van-nav-bar__title">{{ curBrand.Title }}</div>
        </div>

        <wc-list-options v-model="showingList" :data="productList" :size.sync="pageLen"></wc-list-options>
        <div class="product_list">
          <v-data-iterator :items="showingList" :items-per-page="itemsPerPage" :page.sync="pageNo" hide-default-footer class="d-flex flex-column overflow-hidden">
            <template v-slot:no-data>
              <v-progress-linear indeterminate color="cyan" v-show="progressBarVisible"></v-progress-linear>
              <v-alert :value="!progressBarVisible" outlined type="error" elevation="4">
                Sorry, nothing found here :(
              </v-alert>
            </template>

            <template v-slot:default="props">
              <v-row dense align="center" align-content="center">
                <v-col v-for="item in props.items" :key="item.name" cols="6" md="4" lg="3" xl="3" @click="onClickProduct(item)">
                  <v-card flat class="card fill-height">
                    <div class="product_info">
                      <div class="product_image" slot="header">
                        <img v-lazy="item.ImagePath" />
                        <div class="soldout" v-show="(!item.OnHandQty || item.OnHandQty <= 0) && item.NewProduct == 0"></div>
                        <div class="comingsoon" v-show="(!item.OnHandQty || item.OnHandQty <= 0) && item.NewProduct != 0"></div>
                        <div class="newcomer" v-show="item.OnHandQty > 0 && item.NewProduct != 0"></div>
                      </div>
                      <div class="product_title">{{ item.Title }}</div>

                      <div class="product_footer" v-if="item.Price == item.SellingPrice">
                        $ <span class="product_price font_20">{{ item.Price }}</span>
                      </div>
                      <div class="product_footer_2" v-else>
                        <div>
                          $ <span class="product_price_crossout font_12">{{ item.Price }}</span>
                        </div>
                        <div>
                          $ <span class="product_price font_20"> {{ item.SellingPrice }} </span>
                        </div>
                      </div>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </template>

            <template v-slot:footer v-if="numberOfPages > 1">
              <wc-list-footer v-model="pageNo" :maxPage="numberOfPages" />
              <!-- <v-row class="no-gutters mt-auto py-2 shrink" align="center" justify="center">
                <span class="mr-4 grey--text">
                  Page <span v-text="pageNo" class="font-weight-bold primary--text"></span> of {{ numberOfPages }}
                </span>
                <v-btn small dark rounded color="blue darken-3" class="mr-1" v-show="pageNo > 1" @click="prevPage">
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
                <v-btn small dark rounded color="grey" class="mr-1" v-show="pageNo <= 1">
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
                <v-btn small dark rounded color="blue darken-3" class="ml-1" v-show="pageNo < numberOfPages" @click="nextPage">
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
                <v-btn small dark rounded color="grey" class="ml-1" v-show="pageNo >= numberOfPages">
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
              </v-row> -->
            </template>
          </v-data-iterator>
        </div>
      </v-container>
    </ion-content>
  </ion-app>
</template>

<script>
export default {
  data() {
    return {
      curMemberId: 0,
      curBrand: { Title: "" },
      productList: [],
      showingList: [],

      progressBarVisible: true,
      pageNo: 1,
      pageLen: 3,
    };
  },
  // ------------------------------------------------------------------------
  computed: {
    routeBack() {
      return this.$store.state.brandProductList && this.$store.state.brandProductList.routeBack;
    },
    member() {
      return this.$store.state.member;
    },
    needReload() {
      return (this.member.MemberId && this.member.MemberId != this.curMemberId) || (!this.member.MemberId && this.curMemberId != 0);
    },
    // cols="6" sm="4" md="3" xl="2"
    itemsPerPage() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 500; // 2
        case "sm":
          return 500; // 3
        case "md":
          return this.pageLen * 3;
        case "lg":
          return this.pageLen * 4;
        case "xl":
          return this.pageLen * 4;
      }
    },
    numberOfPages() {
      return Math.ceil(this.showingList.length / this.itemsPerPage);
    },
  },
  // ------------------------------------------------------------------------
  activated() {
    this.loadStates();
  },
  // ------------------------------------------------------------------------
  mounted() {
    if (!this.$enableBrands) this.$router.replace({ name: "home" });
    this.curMemberId = null;
    this.loadStates();
  },
  // ------------------------------------------------------------------------
  methods: {
    // ------------------------------------------------------------------------ onClickBack
    onClickBack() {
      if (this.routeBack) {
        this.$router.back(-1);
      } else {
        this.$router.push({ name: "home" });
      }
    },
    // ------------------------------------------------------------------------ nextPage
    nextPage() {
      if (this.pageNo < this.numberOfPages) {
        this.pageNo += 1;
        this.$scrollTop();
      }
    },
    // ------------------------------------------------------------------------ prevPage
    prevPage() {
      if (this.pageNo > 1) {
        this.pageNo -= 1;
        this.$scrollTop();
      }
    },
    // ------------------------------------------------------------------------ loadStates
    loadStates() {
      this.$parent.curTab = null;
      this.$parent.topTab = null;
      if (this.needReload) {
        if (this.$route.params.code) {
          if (!("Id" in this.curBrand)) {
            this.getBrand(this.$route.params.code);
          }
          this.getProductList(this.$route.params.code);
        } else if (
          this.$store.state.brandProductList &&
          "brand" in this.$store.state.brandProductList &&
          "Id" in this.$store.state.brandProductList.brand
        ) {
          this.curBrand = this.$store.state.brandProductList.brand;
          this.getProductList(this.curBrand.Id);
        } else {
          this.$router.push({ name: "home" });
        }
      }
    },
    // ------------------------------------------------------------------------ getCategory
    getBrand(brandId) {
      let $this = this;
      let obj = {
        AppVersion: this.$version,
        language: localStorage.getItem("lang"),
        brandId: brandId,
      };
      $this.$ajax2
        .post("GetBrand", obj, $this.$ajaxHeader)
        .then(function (rpdata) {
          if (rpdata.data.meta.code == "200") {
            $this.curBrand = rpdata.data.data[0];
          }
        }).catch(function (err) { }); // eslint-disable-line
    },
    // ------------------------------------------------------------------------ getProductList
    getProductList(brandId) {
      let $this = this;
      let obj = {
        AppVersion: this.$version,
        language: localStorage.getItem("lang"),
        brandId: brandId,
      };
      if (this.member.SessionId) {
        this.curMemberId = this.member.MemberId;
        obj.SessionId = this.member.SessionId;
        obj.SessionToken = this.member.SessionToken;
      } else {
        this.curMemberId = 0;
      }
      $this.progressBarVisible = true;
      $this.$ajax2
        .post("GetProduct", obj, $this.$ajaxHeader)
        .then(function (rpdata) {
          if (rpdata.data.meta.code == "200") {
            for (let i = 0; i < rpdata.data.data.length; i++) {
              rpdata.data.data[i].Price = rpdata.data.data[i].Price.toFixed(2);
              rpdata.data.data[i].SellingPrice = rpdata.data.data[i].SellingPrice.toFixed(2);
            }
            $this.productList = rpdata.data.data;
            if (rpdata.data.data.length == 0) {
              $this.progressBarVisible = false;
            }
          }
        }).catch(function (err) { }); // eslint-disable-line
    },
    // ------------------------------------------------------------------------ onClickProduct
    onClickProduct(data) {
      let $this = this;
      $this.$store.commit("product", { product: data, routeBack: true });
      // this.$store.commit("incRouteCount");
      $this.$router.push({ name: "product", params: { code: data.Code } });
    },
  },
};
</script>

<style>
#brandProductList {
  margin-bottom: 50px;
}

/* 
#brandProductList .product_title {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

#brandProductList .product_image {
  position: relative;
  width: 80%;
}
#brandProductList .product_image:before {
  content: "";
  display: block;
  padding-top: 80%;
}

#brandProductList .product_image img {
  position: absolute;
  top: 5%;
  left: 20%;
  bottom: 0%;
  right: 0%;
  max-width: 90%;
  max-height: 90%;
  width: auto;
  height: auto;
} 
*/
</style>
